import BPStatement from "components/BPStatement";

const BPStatementPage = () => {
    return <BPStatement />;
};

export default BPStatementPage;
